export const extractPromoIds = (node) => {
    if (!node) return [];

    let ids = [];

    if (node?.config?.promo?.promoId) {
        ids.push(node.config.promo.promoId);
    }

    if (Array.isArray(node.widgets)) {
        node.widgets.forEach((child) => {
            ids = ids.concat(extractPromoIds(child));
        });
    }

    return ids;
};
